import { useEffect, useState } from 'react';
import axios from 'axios';
import Card from 'components/card';
import { CONFIG } from 'variables/config';
import { MdBlock, MdDelete, MdAdd, MdPublic } from 'react-icons/md';

interface IpEntry {
    _id: string;
    ip: string;
    reason: string;
    blockedBy: string;
    createdAt: string;
}

interface CountryEntry {
    _id: string;
    country: string;
    name: string;
    reason: string;
    blockedBy: string;
    createdAt: string;
}

const COUNTRIES: { code: string; name: string }[] = [
    { code: 'AF', name: 'Afghanistan' }, { code: 'AL', name: 'Albania' }, { code: 'DZ', name: 'Algeria' },
    { code: 'AD', name: 'Andorra' }, { code: 'AO', name: 'Angola' }, { code: 'AR', name: 'Argentina' },
    { code: 'AM', name: 'Armenia' }, { code: 'AU', name: 'Australia' }, { code: 'AT', name: 'Austria' },
    { code: 'AZ', name: 'Azerbaijan' }, { code: 'BH', name: 'Bahrain' }, { code: 'BD', name: 'Bangladesh' },
    { code: 'BY', name: 'Belarus' }, { code: 'BE', name: 'Belgium' }, { code: 'BJ', name: 'Benin' },
    { code: 'BT', name: 'Bhutan' }, { code: 'BO', name: 'Bolivia' }, { code: 'BA', name: 'Bosnia and Herzegovina' },
    { code: 'BW', name: 'Botswana' }, { code: 'BR', name: 'Brazil' }, { code: 'BN', name: 'Brunei' },
    { code: 'BG', name: 'Bulgaria' }, { code: 'BF', name: 'Burkina Faso' }, { code: 'BI', name: 'Burundi' },
    { code: 'KH', name: 'Cambodia' }, { code: 'CM', name: 'Cameroon' }, { code: 'CA', name: 'Canada' },
    { code: 'CV', name: 'Cape Verde' }, { code: 'CF', name: 'Central African Republic' }, { code: 'TD', name: 'Chad' },
    { code: 'CL', name: 'Chile' }, { code: 'CN', name: 'China' }, { code: 'CO', name: 'Colombia' },
    { code: 'KM', name: 'Comoros' }, { code: 'CD', name: 'Congo (DRC)' }, { code: 'CG', name: 'Congo (Republic)' },
    { code: 'CR', name: 'Costa Rica' }, { code: 'HR', name: 'Croatia' }, { code: 'CU', name: 'Cuba' },
    { code: 'CY', name: 'Cyprus' }, { code: 'CZ', name: 'Czech Republic' }, { code: 'DK', name: 'Denmark' },
    { code: 'DJ', name: 'Djibouti' }, { code: 'DO', name: 'Dominican Republic' }, { code: 'EC', name: 'Ecuador' },
    { code: 'EG', name: 'Egypt' }, { code: 'SV', name: 'El Salvador' }, { code: 'GQ', name: 'Equatorial Guinea' },
    { code: 'ER', name: 'Eritrea' }, { code: 'EE', name: 'Estonia' }, { code: 'ET', name: 'Ethiopia' },
    { code: 'FJ', name: 'Fiji' }, { code: 'FI', name: 'Finland' }, { code: 'FR', name: 'France' },
    { code: 'GA', name: 'Gabon' }, { code: 'GM', name: 'Gambia' }, { code: 'GE', name: 'Georgia' },
    { code: 'DE', name: 'Germany' }, { code: 'GH', name: 'Ghana' }, { code: 'GR', name: 'Greece' },
    { code: 'GT', name: 'Guatemala' }, { code: 'GN', name: 'Guinea' }, { code: 'GW', name: 'Guinea-Bissau' },
    { code: 'GY', name: 'Guyana' }, { code: 'HT', name: 'Haiti' }, { code: 'HN', name: 'Honduras' },
    { code: 'HU', name: 'Hungary' }, { code: 'IS', name: 'Iceland' }, { code: 'IN', name: 'India' },
    { code: 'ID', name: 'Indonesia' }, { code: 'IR', name: 'Iran' }, { code: 'IQ', name: 'Iraq' },
    { code: 'IE', name: 'Ireland' }, { code: 'IL', name: 'Israel' }, { code: 'IT', name: 'Italy' },
    { code: 'JM', name: 'Jamaica' }, { code: 'JP', name: 'Japan' }, { code: 'JO', name: 'Jordan' },
    { code: 'KZ', name: 'Kazakhstan' }, { code: 'KE', name: 'Kenya' }, { code: 'KP', name: 'North Korea' },
    { code: 'KR', name: 'South Korea' }, { code: 'KW', name: 'Kuwait' }, { code: 'KG', name: 'Kyrgyzstan' },
    { code: 'LA', name: 'Laos' }, { code: 'LV', name: 'Latvia' }, { code: 'LB', name: 'Lebanon' },
    { code: 'LS', name: 'Lesotho' }, { code: 'LR', name: 'Liberia' }, { code: 'LY', name: 'Libya' },
    { code: 'LI', name: 'Liechtenstein' }, { code: 'LT', name: 'Lithuania' }, { code: 'LU', name: 'Luxembourg' },
    { code: 'MG', name: 'Madagascar' }, { code: 'MW', name: 'Malawi' }, { code: 'MY', name: 'Malaysia' },
    { code: 'MV', name: 'Maldives' }, { code: 'ML', name: 'Mali' }, { code: 'MT', name: 'Malta' },
    { code: 'MR', name: 'Mauritania' }, { code: 'MU', name: 'Mauritius' }, { code: 'MX', name: 'Mexico' },
    { code: 'MD', name: 'Moldova' }, { code: 'MC', name: 'Monaco' }, { code: 'MN', name: 'Mongolia' },
    { code: 'ME', name: 'Montenegro' }, { code: 'MA', name: 'Morocco' }, { code: 'MZ', name: 'Mozambique' },
    { code: 'MM', name: 'Myanmar' }, { code: 'NA', name: 'Namibia' }, { code: 'NP', name: 'Nepal' },
    { code: 'NL', name: 'Netherlands' }, { code: 'NZ', name: 'New Zealand' }, { code: 'NI', name: 'Nicaragua' },
    { code: 'NE', name: 'Niger' }, { code: 'NG', name: 'Nigeria' }, { code: 'MK', name: 'North Macedonia' },
    { code: 'NO', name: 'Norway' }, { code: 'OM', name: 'Oman' }, { code: 'PK', name: 'Pakistan' },
    { code: 'PA', name: 'Panama' }, { code: 'PG', name: 'Papua New Guinea' }, { code: 'PY', name: 'Paraguay' },
    { code: 'PE', name: 'Peru' }, { code: 'PH', name: 'Philippines' }, { code: 'PL', name: 'Poland' },
    { code: 'PT', name: 'Portugal' }, { code: 'QA', name: 'Qatar' }, { code: 'RO', name: 'Romania' },
    { code: 'RU', name: 'Russia' }, { code: 'RW', name: 'Rwanda' }, { code: 'SA', name: 'Saudi Arabia' },
    { code: 'SN', name: 'Senegal' }, { code: 'RS', name: 'Serbia' }, { code: 'SL', name: 'Sierra Leone' },
    { code: 'SG', name: 'Singapore' }, { code: 'SK', name: 'Slovakia' }, { code: 'SI', name: 'Slovenia' },
    { code: 'SO', name: 'Somalia' }, { code: 'ZA', name: 'South Africa' }, { code: 'SS', name: 'South Sudan' },
    { code: 'ES', name: 'Spain' }, { code: 'LK', name: 'Sri Lanka' }, { code: 'SD', name: 'Sudan' },
    { code: 'SR', name: 'Suriname' }, { code: 'SE', name: 'Sweden' }, { code: 'CH', name: 'Switzerland' },
    { code: 'SY', name: 'Syria' }, { code: 'TW', name: 'Taiwan' }, { code: 'TJ', name: 'Tajikistan' },
    { code: 'TZ', name: 'Tanzania' }, { code: 'TH', name: 'Thailand' }, { code: 'TL', name: 'Timor-Leste' },
    { code: 'TG', name: 'Togo' }, { code: 'TT', name: 'Trinidad and Tobago' }, { code: 'TN', name: 'Tunisia' },
    { code: 'TR', name: 'Turkey' }, { code: 'TM', name: 'Turkmenistan' }, { code: 'UG', name: 'Uganda' },
    { code: 'UA', name: 'Ukraine' }, { code: 'AE', name: 'United Arab Emirates' }, { code: 'GB', name: 'United Kingdom' },
    { code: 'US', name: 'United States' }, { code: 'UY', name: 'Uruguay' }, { code: 'UZ', name: 'Uzbekistan' },
    { code: 'VE', name: 'Venezuela' }, { code: 'VN', name: 'Vietnam' }, { code: 'YE', name: 'Yemen' },
    { code: 'ZM', name: 'Zambia' }, { code: 'ZW', name: 'Zimbabwe' },
].sort((a, b) => a.name.localeCompare(b.name));

export default function BackOfficeIpBlacklist() {
    const [entries, setEntries] = useState<IpEntry[]>([]);
    const [loading, setLoading] = useState(true);
    const [newIp, setNewIp] = useState('');
    const [newReason, setNewReason] = useState('');
    const [adding, setAdding] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');

    const [countries, setCountries] = useState<CountryEntry[]>([]);
    const [loadingCountries, setLoadingCountries] = useState(true);
    const [newCountry, setNewCountry] = useState('');
    const [newCountryReason, setNewCountryReason] = useState('');
    const [addingCountry, setAddingCountry] = useState(false);
    const [countryError, setCountryError] = useState('');
    const [countrySuccess, setCountrySuccess] = useState('');

    const headers = { Authorization: `Bearer ${localStorage.getItem('token')}` };

    const fetchEntries = async () => {
        try {
            setLoading(true);
            const res = await axios.get(`${CONFIG.apiUrl}/admin/ip-blacklist`, { headers });
            setEntries(res.data);
        } catch (e) {
            setError('Failed to load blacklist.');
        } finally {
            setLoading(false);
        }
    };

    const fetchCountries = async () => {
        try {
            setLoadingCountries(true);
            const res = await axios.get(`${CONFIG.apiUrl}/admin/country-blacklist`, { headers });
            setCountries(res.data);
        } catch (e) {
            setCountryError('Failed to load country blacklist.');
        } finally {
            setLoadingCountries(false);
        }
    };

    useEffect(() => {
        fetchEntries();
        fetchCountries();
    }, []);

    const handleAdd = async (e: React.FormEvent) => {
        e.preventDefault();
        setError('');
        setSuccess('');
        if (!newIp.trim()) return;
        if (newIp.trim() === '::1') {
            setError('This IP cannot be blacklisted');
            return;
        }
        try {
            setAdding(true);
            await axios.post(`${CONFIG.apiUrl}/admin/ip-blacklist`, { ip: newIp.trim(), reason: newReason.trim() }, { headers });
            setSuccess(`IP ${newIp.trim()} blacklisted.`);
            setNewIp('');
            setNewReason('');
            fetchEntries();
        } catch (e: any) {
            setError(e.response?.data?.message || 'Error adding IP.');
        } finally {
            setAdding(false);
        }
    };

    const handleDelete = async (ip: string) => {
        setError('');
        setSuccess('');
        try {
            await axios.delete(`${CONFIG.apiUrl}/admin/ip-blacklist/${encodeURIComponent(ip)}`, { headers });
            setSuccess(`IP ${ip} removed.`);
            fetchEntries();
        } catch (e: any) {
            setError(e.response?.data?.message || 'Error removing IP.');
        }
    };

    const handleAddCountry = async (e: React.FormEvent) => {
        e.preventDefault();
        setCountryError('');
        setCountrySuccess('');
        if (!newCountry) return;
        const found = COUNTRIES.find((c) => c.code === newCountry);
        try {
            setAddingCountry(true);
            await axios.post(
                `${CONFIG.apiUrl}/admin/country-blacklist`,
                { country: newCountry, name: found?.name || newCountry, reason: newCountryReason.trim() },
                { headers }
            );
            setCountrySuccess(`${found?.name || newCountry} blocked.`);
            setNewCountry('');
            setNewCountryReason('');
            fetchCountries();
        } catch (e: any) {
            setCountryError(e.response?.data?.message || 'Error adding country.');
        } finally {
            setAddingCountry(false);
        }
    };

    const handleDeleteCountry = async (code: string) => {
        setCountryError('');
        setCountrySuccess('');
        try {
            await axios.delete(`${CONFIG.apiUrl}/admin/country-blacklist/${encodeURIComponent(code)}`, { headers });
            const name = COUNTRIES.find((c) => c.code === code)?.name || code;
            setCountrySuccess(`${name} removed.`);
            fetchCountries();
        } catch (e: any) {
            setCountryError(e.response?.data?.message || 'Error removing country.');
        }
    };

    const availableCountries = COUNTRIES.filter((c) => !countries.some((e) => e.country === c.code));

    return (
        <div className="pt-[50px] flex flex-col gap-6">

            {/* ── IP Blacklist ── */}
            <Card extra="p-5">
                <div className="mb-6 flex items-center gap-3">
                    <MdBlock className="text-2xl text-red-500" />
                    <h2 className="text-2xl font-bold text-navy-700 dark:text-white">IP Blacklist</h2>
                    <span className="ml-2 rounded-full bg-red-100 px-3 py-0.5 text-sm font-semibold text-red-700">
                        {entries.length} blocked
                    </span>
                </div>

                <form onSubmit={handleAdd} className="mb-6 flex flex-wrap items-end gap-3 rounded-xl bg-gray-50 p-4 dark:bg-navy-800">
                    <div>
                        <label className="mb-1 block text-xs font-semibold uppercase text-gray-500">IP Address *</label>
                        <input
                            type="text"
                            value={newIp}
                            onChange={(e) => setNewIp(e.target.value)}
                            placeholder="e.g. 192.168.1.1"
                            className="w-48 rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm focus:border-red-400 focus:outline-none dark:border-navy-600 dark:bg-navy-700 dark:text-white"
                            required
                        />
                    </div>
                    <div className="flex-1 min-w-[180px]">
                        <label className="mb-1 block text-xs font-semibold uppercase text-gray-500">Reason</label>
                        <input
                            type="text"
                            value={newReason}
                            onChange={(e) => setNewReason(e.target.value)}
                            placeholder="e.g. Brute force attack"
                            className="w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm focus:border-red-400 focus:outline-none dark:border-navy-600 dark:bg-navy-700 dark:text-white"
                        />
                    </div>
                    <button
                        type="submit"
                        disabled={adding}
                        className="flex items-center gap-2 rounded-lg bg-red-600 px-4 py-2 text-sm font-medium text-white hover:bg-red-700 disabled:opacity-50"
                    >
                        <MdAdd className="text-lg" />
                        {adding ? 'Blocking...' : 'Block IP'}
                    </button>
                </form>

                {error && (
                    <div className="mb-4 rounded-lg bg-red-100 p-3 text-sm text-red-700 dark:bg-red-900/30 dark:text-red-400">{error}</div>
                )}
                {success && (
                    <div className="mb-4 rounded-lg bg-green-100 p-3 text-sm text-green-700 dark:bg-green-900/30 dark:text-green-400">{success}</div>
                )}

                {loading ? (
                    <div className="py-10 text-center text-gray-400">Loading...</div>
                ) : entries.length === 0 ? (
                    <div className="py-10 text-center text-gray-400">No IPs blacklisted.</div>
                ) : (
                    <div className="overflow-x-auto">
                        <table className="w-full text-left text-sm">
                            <thead>
                                <tr className="border-b border-gray-200 dark:border-navy-600">
                                    <th className="pb-3 pr-6 text-xs font-bold uppercase text-gray-500">IP</th>
                                    <th className="pb-3 pr-6 text-xs font-bold uppercase text-gray-500">Reason</th>
                                    <th className="pb-3 pr-6 text-xs font-bold uppercase text-gray-500">Blocked by</th>
                                    <th className="pb-3 pr-6 text-xs font-bold uppercase text-gray-500">Date</th>
                                    <th className="pb-3 text-xs font-bold uppercase text-gray-500">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {entries.map((entry) => (
                                    <tr key={entry._id} className="border-b border-gray-100 dark:border-navy-700">
                                        <td className="py-3 pr-6 font-mono font-semibold text-red-600">{entry.ip}</td>
                                        <td className="py-3 pr-6 text-gray-600 dark:text-gray-400">{entry.reason || '—'}</td>
                                        <td className="py-3 pr-6 text-gray-500">{entry.blockedBy || '—'}</td>
                                        <td className="py-3 pr-6 text-gray-500">
                                            {new Date(entry.createdAt).toLocaleString('fr-FR')}
                                        </td>
                                        <td className="py-3">
                                            <button
                                                onClick={() => handleDelete(entry.ip)}
                                                className="flex items-center gap-1 rounded-lg bg-gray-100 px-3 py-1 text-xs font-medium text-red-600 hover:bg-red-50 dark:bg-navy-700 dark:hover:bg-red-900/30"
                                            >
                                                <MdDelete />
                                                Remove
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </Card>

            {/* ── Country Blacklist ── */}
            <Card extra="p-5">
                <div className="mb-6 flex items-center gap-3">
                    <MdPublic className="text-2xl text-orange-500" />
                    <h2 className="text-2xl font-bold text-navy-700 dark:text-white">Country Blacklist</h2>
                    <span className="ml-2 rounded-full bg-orange-100 px-3 py-0.5 text-sm font-semibold text-orange-700">
                        {countries.length} blocked
                    </span>
                </div>

                <form onSubmit={handleAddCountry} className="mb-6 flex flex-wrap items-end gap-3 rounded-xl bg-gray-50 p-4 dark:bg-navy-800">
                    <div>
                        <label className="mb-1 block text-xs font-semibold uppercase text-gray-500">Country *</label>
                        <select
                            value={newCountry}
                            onChange={(e) => setNewCountry(e.target.value)}
                            className="w-56 rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm focus:border-orange-400 focus:outline-none dark:border-navy-600 dark:bg-navy-700 dark:text-white"
                            required
                        >
                            <option value="">Select a country…</option>
                            {availableCountries.map((c) => (
                                <option key={c.code} value={c.code}>{c.name} ({c.code})</option>
                            ))}
                        </select>
                    </div>
                    <div className="flex-1 min-w-[180px]">
                        <label className="mb-1 block text-xs font-semibold uppercase text-gray-500">Reason</label>
                        <input
                            type="text"
                            value={newCountryReason}
                            onChange={(e) => setNewCountryReason(e.target.value)}
                            placeholder="e.g. High fraud rate"
                            className="w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm focus:border-orange-400 focus:outline-none dark:border-navy-600 dark:bg-navy-700 dark:text-white"
                        />
                    </div>
                    <button
                        type="submit"
                        disabled={addingCountry || !newCountry}
                        className="flex items-center gap-2 rounded-lg bg-orange-500 px-4 py-2 text-sm font-medium text-white hover:bg-orange-600 disabled:opacity-50"
                    >
                        <MdAdd className="text-lg" />
                        {addingCountry ? 'Blocking...' : 'Block Country'}
                    </button>
                </form>

                {countryError && (
                    <div className="mb-4 rounded-lg bg-red-100 p-3 text-sm text-red-700 dark:bg-red-900/30 dark:text-red-400">{countryError}</div>
                )}
                {countrySuccess && (
                    <div className="mb-4 rounded-lg bg-green-100 p-3 text-sm text-green-700 dark:bg-green-900/30 dark:text-green-400">{countrySuccess}</div>
                )}

                {loadingCountries ? (
                    <div className="py-10 text-center text-gray-400">Loading...</div>
                ) : countries.length === 0 ? (
                    <div className="py-10 text-center text-gray-400">No countries blacklisted.</div>
                ) : (
                    <div className="overflow-x-auto">
                        <table className="w-full text-left text-sm">
                            <thead>
                                <tr className="border-b border-gray-200 dark:border-navy-600">
                                    <th className="pb-3 pr-6 text-xs font-bold uppercase text-gray-500">Country</th>
                                    <th className="pb-3 pr-6 text-xs font-bold uppercase text-gray-500">Code</th>
                                    <th className="pb-3 pr-6 text-xs font-bold uppercase text-gray-500">Reason</th>
                                    <th className="pb-3 pr-6 text-xs font-bold uppercase text-gray-500">Blocked by</th>
                                    <th className="pb-3 pr-6 text-xs font-bold uppercase text-gray-500">Date</th>
                                    <th className="pb-3 text-xs font-bold uppercase text-gray-500">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {countries.map((entry) => (
                                    <tr key={entry._id} className="border-b border-gray-100 dark:border-navy-700">
                                        <td className="py-3 pr-6 font-semibold text-orange-600">{entry.name || entry.country}</td>
                                        <td className="py-3 pr-6 font-mono text-gray-500">{entry.country}</td>
                                        <td className="py-3 pr-6 text-gray-600 dark:text-gray-400">{entry.reason || '—'}</td>
                                        <td className="py-3 pr-6 text-gray-500">{entry.blockedBy || '—'}</td>
                                        <td className="py-3 pr-6 text-gray-500">
                                            {new Date(entry.createdAt).toLocaleString('fr-FR')}
                                        </td>
                                        <td className="py-3">
                                            <button
                                                onClick={() => handleDeleteCountry(entry.country)}
                                                className="flex items-center gap-1 rounded-lg bg-gray-100 px-3 py-1 text-xs font-medium text-orange-600 hover:bg-orange-50 dark:bg-navy-700 dark:hover:bg-orange-900/30"
                                            >
                                                <MdDelete />
                                                Remove
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </Card>
        </div>
    );
}
